export enum languages {
    pl,
    gb,
    de,
};